import { render, staticRenderFns } from "./attach1_kor.vue?vue&type=template&id=7c7f5756&scoped=true&"
import script from "./attach1_kor.vue?vue&type=script&lang=js&"
export * from "./attach1_kor.vue?vue&type=script&lang=js&"
import style0 from "./attach1_kor.vue?vue&type=style&index=0&id=7c7f5756&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f5756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
